import Steps from './steps'
import StepItem from './stepItem'

Steps.Item = StepItem

export default Steps